import React, { useEffect, useState } from 'react';
import './Hero.css';

function Counter({ target, suffix = '', prefix = '' }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const step = Math.ceil(target / 60);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 25);
    return () => clearInterval(timer);
  }, [target]);
  return <span>{prefix}{count.toLocaleString('fr-FR')}{suffix}</span>;
}

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__noise" aria-hidden="true" />
      <div className="hero__scan" aria-hidden="true" />

      <div className="container hero__content">
        <div className="hero__badge">⚠️ ALERTE FRAUDE ACTIVE</div>

        <h1 id="hero-title" className="hero__title">
          <span className="hero__title-site">JUMPVENDOR.COM</span>
          <br />
          <span className="hero__title-main">EST UNE ARNAQUE</span>
        </h1>

        <p className="hero__subtitle">
          Des centaines de victimes piégées via TikTok. Prélèvements multiples, abonnements cachés,
          redirection frauduleuse. Ce site expose leur système et vous aide à agir.
        </p>

        <div className="hero__stats">
          <div className="hero__stat">
            <div className="hero__stat-number"><Counter target={347} suffix="+" /></div>
            <div className="hero__stat-label">Victimes signalées</div>
          </div>
          <div className="hero__stat-divider" aria-hidden="true" />
          <div className="hero__stat">
            <div className="hero__stat-number"><Counter prefix="~" target={89} suffix="€" /></div>
            <div className="hero__stat-label">Perdus en moyenne</div>
          </div>
          <div className="hero__stat-divider" aria-hidden="true" />
          <div className="hero__stat">
            <div className="hero__stat-number"><Counter target={3} /></div>
            <div className="hero__stat-label">Prélèvements surprise</div>
          </div>
        </div>

        <div className="hero__cta-group">
          <a href="#signaler" className="hero__cta hero__cta--primary">
            🚨 Signaler l'arnaque maintenant
          </a>
          <a href="#comment-ca-marche" className="hero__cta hero__cta--secondary">
            📖 Voir comment ils opèrent
          </a>
        </div>

        <div className="hero__warning-box" role="alert">
          <div className="hero__warning-icon">🔴</div>
          <p>
            <strong>Vous avez été prélevé par JumpVendor ?</strong> Contactez immédiatement votre banque pour
            une opposition et signalez la fraude à la DGCCRF au <a href="tel:0809540550">0809 540 550</a>.
          </p>
        </div>
      </div>
    </section>
  );
}
